var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58974 18.5C8.63333 18.5 9.48718 17.6462 9.48718 16.6026H5.69231C5.69231 17.6462 6.54615 18.5 7.58974 18.5ZM13.2821 12.8077V8.0641C13.2821 5.15154 11.7356 2.71333 9.01282 2.0682V1.42308C9.01282 0.635641 8.37718 0 7.58974 0C6.80231 0 6.16667 0.635641 6.16667 1.42308V2.0682C3.45333 2.71333 1.89744 5.14205 1.89744 8.0641V12.8077L0 14.7051V15.6538H15.1795V14.7051L13.2821 12.8077ZM11.3846 13.7564H3.79487V8.0641C3.79487 5.71128 5.22744 3.79487 7.58974 3.79487C9.95205 3.79487 11.3846 5.71128 11.3846 8.0641V13.7564Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderNotification);
export default __webpack_public_path__ + "static/media/header-notification.0a6c14cd.svg";
export { ForwardRef as ReactComponent };